<template>
  <el-dialog
    v-el-drag-dialog
    :visible.sync="innerVisible"
    :title="$t('AirExport.CustomsClearanceTracking')"
    :width="$selectByLang('650px', '810px')"
    :close-on-click-modal="false"
    class="details-view"
  >
    <div class="main-content">
      <div class="section">
        <span class="title">{{ $t('Warehouse.JobNumberInformation') }}</span>
        <el-form :inline="true" :label-width="$selectByLang('70px', '100px')" label-position="left">
          <el-form-item :label="$t('CargoMsg.Cargo_BusinessNo')">
            <el-input v-model="job.jobNo" :disabled="true" no="1" />
          </el-form-item>
          <!-- 占位 -->
          <el-form-item />
          <el-form-item :label="$t('SeaExport.FlightNo')">
            <el-input :disabled="true" :value="job.voyageFlight" no="2" />
          </el-form-item>
          <el-form-item :label="$t('CargoMsg.Cargo_ActualQuantity')">
            <el-input-number v-model="job.quantityActual" :controls="false" style="width: 100%;" no="3" />
          </el-form-item>
          <el-form-item :label="$t('CargoMsg.Cargo_OperationDate')">
            <el-date-picker v-model="job.customsDate" type="date" value-format="yyyy-MM-dd" style="width: 100%" clearable no="4" />
          </el-form-item>
          <el-form-item :label="$t('CargoMsg.Cargo_ActualWeight')">
            <div style="display: flex">
              <el-input-number v-model="job.weightActual" style="width: 168px" :controls="false" no="5" />
              <span style="margin-left: 5px;">KGS</span>
            </div>
          </el-form-item>
          <el-form-item :label="$t('CargoMsg.Cargo_SailingDate')">
            <el-date-picker v-model="job.etd" type="date" value-format="yyyy-MM-dd" style="width: 100%" clearable no="6" />
          </el-form-item>
          <el-form-item :label="$t('CargoMsg.Cargo_ActualVolume')">
            <div style="display: flex">
              <el-input-number v-model="job.cubageActual" style="width: 168px" :controls="false" no="7" />
              <span style="margin-left: 5px;">
                M<sup>3</sup>
              </span>
            </div>
          </el-form-item>
        </el-form>
      </div>
      <div class="section">
        <span class="title">{{ $t('AirExport.CustomsClearanceInformation') }}</span>
        <el-form>
          <el-form-item>
            <el-checkbox v-model="multipleCustomsInfo" no="8">{{ $t('AirExport.MultipleCustomsDeclarations') }}</el-checkbox>
          </el-form-item>
        </el-form>
        <cargo-ag-grid
          v-show="multipleCustomsInfo"
          :grid-options="gridOptions"
          :column-defs="columnDefs"
          :row-data="rowData"
          @gridReady="params=>{gridApi=params.api}"
        />
        <div v-show="multipleCustomsInfo" style="margin: 5px 0;">
          <span style="float: right;">
            <div v-if="!isEdit">
              <el-button type="primary" no="9" @click="addHandler">{{ $t('CargoMsg.Cargo_Add') }}</el-button>
              <el-button type="primary" no="10" @click="editHandler">{{ $t('CargoMsg.Cargo_Edit') }}</el-button>
              <el-button type="primary" no="11" @click="delHandler">{{ $t('CargoMsg.Cargo_Delete') }}</el-button>
            </div>
            <div v-else>
              <el-button type="primary" no="12" @click="saveHandler">{{ $t('CargoMsg.Cargo_Save') }}</el-button>
              <el-button no="13" @click="cancelHandler">{{ $t('Message.Cancel') }}</el-button>
            </div>
          </span>
        </div>
        <el-form :disabled="!isEdit" :inline="true" :label-width="$selectByLang('70px', '170px')" label-position="left">
          <el-form-item label-width="0">
            <el-checkbox v-model="customsInfo.commodityInspection" no="14">{{ $t('AirExport.WhetherApplyForCommercialInspection') }}</el-checkbox>
            <el-checkbox v-model="customsInfo.spotInspection" no="15">{{ $t('AirExport.WhetherToCheck') }}</el-checkbox>
          </el-form-item>
          <el-form-item :label="$t('SeaExport.StatusOfCustomsDeclaration')" style="margin-left: 170px;">
            <el-select v-model="customsInfo.declareCustomsState" style="width: 150px" no="16">
              <el-option v-for="(item,index) in DECLARE_CUSTOMS_STATE" :key="index" :label="$getLangColumn(item)" :value="item.code" />
            </el-select>
          </el-form-item>
          <el-form-item :label="$t('SeaExport.TenBitCode')">
            <el-input v-model="customsInfo.tenDigitCode" :maxlength="10" style="width: 100px" no="17" @blur="tenDigitCodeChangeHandler" />
          </el-form-item>
          <el-form-item :label="$t('AirExport.CustomsClearanceQuantity')">
            <el-input-number v-model="customsInfo.quantityActual" :controls="false" style="width: 150px" no="18" @change="textChangeHandler" />
          </el-form-item>
          <el-form-item :label="$t('SeaExport.OperatingCompany')">
            <el-input v-model="customsInfo.companyCname" no="19" @blur="queryBusinessHandler" />
          </el-form-item>
          <el-form-item :label="$t('AirExport.CustomsClearanceWeight')">
            <div style="display: flex">
              <el-input-number v-model="customsInfo.weightActual" style="width: 150px" :controls="false" no="20" @change="textChangeHandler" />
              <span style="margin-left: 5px;">KGS</span>
            </div>
          </el-form-item>
          <el-form-item :label="$t('AirExport.CustomsClearanceDate')">
            <el-date-picker v-model="customsInfo.customsDate" type="date" value-format="yyyy-MM-dd" style="width: 120px" clearable no="21" />
          </el-form-item>
          <!-- 占位 -->
          <el-form-item />
          <el-form-item :label="$t('CargoMsg.Cargo_Remarks')">
            <el-input v-model="customsInfo.remarks" type="textarea" :rows="5" style="width: 530px" no="22" />
          </el-form-item>
        </el-form>
      </div>
    </div>
    <span slot="footer">
      <el-button type="primary" no="23" @click="okEventHandler">{{ $t('CargoMsg.Cargo_Confirm') }}</el-button>
      <el-button no="24" @click="innerVisible=false">{{ $t('Message.Cancel') }}</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { getLoading4Cxt } from '@/utils/utilBaseElement'
import ColumnUtils from '@/utils/ColumnUtils'
import { AutoIncrementNum } from '@/utils/commonUtil'
import { Job } from '@/class/model/booking/Job'
import { CustomsInfo } from '@/class/model/booking/CustomsInfo'
import { DECLARE_CUSTOMS_STATE, STATE_BH } from '@/class/cargo/model/parameters/SystemConstants'
import { customsList, customsInfoBatchSave } from '@/api/seaExport/customsInfo'
import { getBusinessByTenDigitCode, getBusinessByCompany, businessCheckSaveUpdate } from '@/api/seaExport/file'

export default {
  name: 'CustomsMaintainDialog',
  props: {
    visible: { type: Boolean, required: true },
    job: { type: Object, required: true }
  },
  data() {
    return {
      innerVisible: false,
      DECLARE_CUSTOMS_STATE,
      refershCustomDate: false, // 是否需要刷新报关日期
      multipleCustomsInfo: false,
      gridOptions: {
        rowSelection: 'single',
        suppressCellSelection: true, // 如果为true，则不能选择单元格
        suppressRowClickSelection: true, // 如果为true，则单击行时不会发生行选择
        onRowDataChanged: event => {
          // 清除单选行
          event.api.clearFocusedCell()
        },
        onCellFocused: event => {
          const nodes = event.api.rowModel.rowsToDisplay
          this.selectedNode = nodes[event.rowIndex] || null
        },
        onSortChanged: event => {
          // 重置单选行
          if (this.selectedNode) {
            event.api.setFocusedCell(this.selectedNode.rowIndex, event.columnApi.getAllDisplayedColumns()[0])
          }
        },
        context: { componentParent: this }
      },
      columnDefs: [
        {
          headerName: this.$t('CargoMsg.Cargo_OperatingCompany'),
          field: 'companyCname',
          width: 200
        }, {
          headerName: this.$t('AirExport.CustomsClearanceQuantity'),
          field: 'quantityActual',
          valueFormatter: params => {
            return ColumnUtils.formatNumber(params.value, 0, false, false)
          }
        }, {
          headerName: this.$t('AirExport.CustomsClearanceWeight'),
          field: 'weightActual',
          valueFormatter: params => {
            return ColumnUtils.number1ColumnLabelFunc(params.value)
          }
        }
      ],
      rowData: [],
      selectedNode: null,
      customsInfo: {},
      gridApi: null,
      isEdit: false,
      deletedKeys: [],
      autoIncrementNum: new AutoIncrementNum()
    }
  },
  watch: {
    visible: {
      immediate: true,
      handler(newVal) {
        if (newVal) {
          const loading = getLoading4Cxt(this)
          customsList(this.job.uuid).then(res => {
            for (const item of res.data) {
              item.seq = this.autoIncrementNum.getNextNum()
              if (item.declareCustomsState !== STATE_BH.code) {
                this.refershCustomDate = false
              }
            }
            this.multipleCustomsInfo = res.data.length > 1
            this.rowData = res.data
            this.refershCustomDate = this.refCustomDateDirty()
            if (this.rowData.length > 0) {
              setTimeout(() => {
                this.gridApi.setFocusedCell(0, this.gridApi.columnController.getAllDisplayedColumns()[0])
              }, 100)
            }
            this.isEdit = true
          }).finally(() => {
            loading.close()
          })
        }
        this.innerVisible = newVal
      }
    },
    innerVisible(newVal) {
      this.$emit('update:visible', newVal)
      if (!newVal) {
        this.refershCustomDate = false
        this.multipleCustomsInfo = false
        this.rowData = []
        this.isEdit = false
        this.deletedKeys = []
      }
    },
    selectedNode: {
      immediate: true,
      handler(newVal) {
        if (newVal) {
          this.customsInfo = { ...newVal.data }
        } else {
          const data = new CustomsInfo().fillDefaultValue().getData()
          data.jobUuid = this.job.uuid
          data.seq = this.autoIncrementNum.getNextNum()
          this.customsInfo = data
        }
      }
    }
  },
  methods: {
    refCustomDateDirty() {
      for (const item of this.rowData) {
        if (item.declareCustomsState !== STATE_BH.code) {
          return false
        }
      }
      return true
    },
    addHandler() {
      this.gridApi.clearFocusedCell()
      this.isEdit = true
    },
    tenDigitCodeChangeHandler() {
      if (this.customsInfo.tenDigitCode.length === 10) {
        getBusinessByTenDigitCode(this.customsInfo.tenDigitCode).then(res => {
          if (res.data && res.data.length > 0) {
            const business = res.data[0]
            if (business) {
              this.customsInfo.companyCname = business.companyCname
            }
          }
        })
      }
    },
    queryBusinessHandler() {
      if (this.customsInfo.companyCname && this.customsInfo.tenDigitCode.length !== 10) {
        getBusinessByCompany(this.customsInfo.companyCname, false).then(res => {
          if (res.data && res.data.length > 0) {
            const business = res.data[0]
            if (business) {
              this.customsInfo.companyCname = business.companyCname
            }
          }
        })
      }
    },
    textChangeHandler() {
      const row = this.rowData.find(p => p.seq === this.customsInfo.seq)
      if (row) {
        row.quantityActual = Math.floor(this.customsInfo.quantityActual)
        row.weightActual = this.customsInfo.weightActual
        this.gridApi.refreshCells({ force: true })
      }
      this.refJobQWC()
    },
    // 刷新job件重体
    refJobQWC() {
      let quantityTotal = 0
      let weightTotal = 0
      for (const item of this.rowData) {
        quantityTotal += item.quantityActual
        weightTotal += item.weightActual
      }
      if (this.rowData.findIndex(p => p.seq === this.customsInfo.seq) === -1) {
        quantityTotal += Math.floor(this.customsInfo.quantityActual)
        weightTotal += this.customsInfo.weightActual
      }
      this.job.quantityActual = quantityTotal
      this.job.weightActual = weightTotal
    },
    editHandler() {
      if (!this.selectedNode) {
        this.$message.info(this.$t('AirExport.PleaseSelectCustomsClearanceInformation'))
        return
      }
      this.isEdit = true
    },
    delHandler() {
      if (!this.selectedNode) {
        this.$message.info(this.$t('AirExport.PleaseSelectCustomsClearanceInformation'))
        return
      }
      if (this.customsInfo.uuid) {
        this.deletedKeys.push(this.customsInfo.uuid)
      }
      const index = this.rowData.findIndex(p => p.seq === this.customsInfo.seq)
      this.rowData.splice(index, 1)
      this.refJobQWC()
    },
    saveHandler() {
      if (this.customsInfo.tenDigitCode.length <= 10) {
        businessCheckSaveUpdate({
          tenDigitCode: this.customsInfo.tenDigitCode,
          companyCName: this.customsInfo.companyCname
        })
      }
      this.customsInfo.quantityActual = Math.floor(this.customsInfo.quantityActual)
      const row = this.rowData.find(p => p.seq === this.customsInfo.seq)
      if (row) {
        Object.assign(row, this.customsInfo)
        this.gridApi.refreshCells({ forece: true })
        this.gridApi.clearFocusedCell()
      } else {
        this.rowData.push(this.customsInfo)
      }
      this.isEdit = false
    },
    cancelHandler() {
      this.gridApi.clearFocusedCell()
      this.isEdit = false
    },
    okEventHandler() {
      if (this.isEdit) {
        this.saveHandler()
      }
      this.job.customsDate = this.customsInfo.customsDate
      if (!this.refershCustomDate) {
        this.refCustomDateDirty()
      }
      if (this.rowData.length > 0) {
        if (!this.checkJobQWC()) {
          this.$message.info(this.$t('AirExport.TheBeEqualToBusiness'))
          return
        }
      }
      for (let i = 0; i < this.rowData.length; ++i) {
        new CustomsInfo(this.rowData[i]).emptyObjectToNull()
        if (i === 0) {
          new Job(this.job).emptyObjectToNull()
          this.rowData[i].job = this.job
        }
      }
      const loading = getLoading4Cxt(this)
      console.log(this.rowData)
      customsInfoBatchSave(this.rowData, { deletedKeys: this.deletedKeys }).then(res => {
        loading.close()
        this.innerVisible = false
        this.$emit('callback', res.data)
      }).catch(() => {
        loading.close()
      })
    },
    // 如果报关日期小于当前 且 报关状态是报好，则更新Job报关日期为当前日期
    refJobCustomDate() {
      if (this.rowData.length > 1) {
        if (this.rowData.length === 1) {
          this.job.declareCustomsState = this.rowData[0].declareCustomsState
          if (this.job.declareCustomsState === 4) {
            this.job.customsDate = ColumnUtils.dateLabelFunc(new Date())
          }
        } else {
          const isRef = this.refCustomDateDirty()
          if (isRef) {
            this.job.declareCustomsState = STATE_BH.code
            this.job.customsDate = ColumnUtils.dateLabelFunc(new Date())
          } else {
            this.job.declareCustomsState = STATE_BH.code
          }
        }
      } else {
        this.job.declareCustomsState = 0
      }
    },
    // 检查报关件重的总和是否等于Job件重
    checkJobQWC() {
      let quantityTotal = 0
      let weightTotal = 0
      for (const item of this.rowData) {
        quantityTotal += item.quantityActual
        weightTotal += item.weightActual
      }
      if (this.job.quantityActual !== quantityTotal || this.job.weightActual !== weightTotal) {
        return false
      }
      return true
    }
  }
}
</script>

<style scoped lang="scss">
#app .app-main-content .details-view .main-content ::v-deep {
  height: 475px;
  overflow-y: auto;
  .section .el-form-item__content {
    width: 200px;
  }
}
</style>
